import { CONSTANTS, HELPERS } from '@/utils';
import { useEffect, useState } from 'react';

const getItemTitle = (title, payload) => {
  if (!payload) {
    return title || 'Item';
  }

  if (payload.purchasable_type === CONSTANTS.PRODUCT_TYPE.EVENT.id) {
    return `Pembelian Event - ${title}`;
  }

  const { label } = HELPERS.typeOfPurchasable(payload.purchasable_type);
  let itemTitle = `${label} ${title}`;
  if (payload.subscribeable_title != null) {
    itemTitle = `${itemTitle} ${itemTitle.indexOf('Program Belajar') === -1 ? ' - Program Belajar' : ''} ${
      payload.subscribeable_title
    }`;
  }
  return itemTitle;
};

// Check if this is a bulk transaction
const isBulkTransaction = (payload) => {
  return (
    payload?.transaction_items && Array.isArray(payload.transaction_items) && payload.transaction_items.length > 0
  );
};

function PriceList({ items, typePurchase, payload }) {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (items?.length > 0) {
      setTotal(items.reduce((acc, item) => acc + item.value, 0));
    }
  }, [items]);

  if (!items || !payload) return null;

  const isBulk = isBulkTransaction(payload);

  // Group transaction items by type for bulk transactions
  const groupedTransactionItems = (() => {
    if (!isBulk || !payload?.transaction_items) return {};

    return payload.transaction_items.reduce((acc, item) => {
      const cat = item.item_type;
      acc[cat] = acc[cat] || [];
      acc[cat].push(item);
      return acc;
    }, {});
  })();

  return (
    <div className="w-full">
      <div className="text-sm text-gray-700 space-y-1">
        {/* Items List - Only show for non-bulk or summary items (subtotals, discounts, total) */}
        {items.map((item, index) => (
          <div key={`${item.title}-${index}`} className="flex justify-between">
            <div className="flex-1">{isBulk ? item.title : getItemTitle(item.title, payload)}</div>
            <div className={`text-right text-base ${item.value < 0 ? 'text-red-500' : ''}`}>
              {item.value < 0
                ? `- Rp ${HELPERS.numberFormat(Math.abs(item.value))}`
                : `Rp ${HELPERS.numberFormat(item.value)}`}
            </div>
          </div>
        ))}

        {/* Total */}
        <hr className="my-3 border-gray-200" />
        <div className="flex justify-between font-bold text-lg text-gray-800">
          <div>Total</div>
          <div className="text-right">{total > 0 ? `Rp ${HELPERS.numberFormat(Math.abs(total))}` : 'GRATIS'}</div>
        </div>
      </div>
    </div>
  );
}

export default PriceList;
